<template>
    <v-container fluid>
        <v-layout column align-center>

            <v-snackbar
                    v-model="snackbar"
                    color="warning"
                    :multi-line="false"
                    :timeout="4000"
                    :top="true"
                    :vertical="false"
            >
                For mange bogstaver, kun 6 bogstaver!
                <v-btn
                        dark
                        flat
                        @click="snackbar = false"
                >
                    Close
                </v-btn>
            </v-snackbar>

            <h1>Ruko Garant D12 1200</h1>

            <v-form>
                <v-text-field
                        v-model="string"
                        label="Input"
                        :readonly="true"
                ></v-text-field>
                <v-text-field
                        v-model="result"
                        label="Result"
                        :readonly="true"
                ></v-text-field>

                <v-btn dark block color="indigo" @click="resetString">
                    Nulstil
                </v-btn>

                <div class="text-xs-center">
                    <v-btn fab dark small color="indigo" @click="appendLetter('A')">
                        A
                    </v-btn>
                    <v-btn fab dark small color="indigo" @click="appendLetter('B')">
                        B
                    </v-btn>
                    <v-btn fab dark small color="indigo" @click="appendLetter('C')">
                        C
                    </v-btn>
                    <v-btn fab dark small color="indigo" @click="appendLetter('D')">
                        D
                    </v-btn>
                    <v-btn fab dark small color="indigo" @click="appendLetter('E')">
                        E
                    </v-btn>
                    <v-btn fab dark small color="indigo" @click="appendLetter('F')">
                        F
                    </v-btn>
                    <v-btn fab dark small color="indigo" @click="appendLetter('G')">
                        G
                    </v-btn>
                    <v-btn fab dark small color="indigo" @click="appendLetter('H')">
                        H
                    </v-btn>
                    <v-btn fab dark small color="indigo" @click="appendLetter('I')">
                        I
                    </v-btn>
                    <v-btn fab dark small color="indigo" @click="appendLetter('J')">
                        J
                    </v-btn>
                    <v-btn fab dark small color="indigo" @click="appendLetter('K')">
                        K
                    </v-btn>
                    <v-btn fab dark small color="indigo" @click="appendLetter('L')">
                        L
                    </v-btn>
                    <v-btn fab dark small color="indigo" @click="appendLetter('M')">
                        M
                    </v-btn>
                    <v-btn fab dark small color="indigo" @click="appendLetter('N')">
                        N
                    </v-btn>
                    <v-btn fab dark small color="indigo" @click="appendLetter('P')">
                        P
                    </v-btn>
                    <v-btn fab dark small color="indigo" @click="appendLetter('Q')">
                        Q
                    </v-btn>
                    <v-btn fab dark small color="indigo" @click="appendLetter('R')">
                        R
                    </v-btn>
                    <v-btn fab dark small color="indigo" @click="appendLetter('S')">
                        S
                    </v-btn>
                    <v-btn fab dark small color="indigo" @click="appendLetter('T')">
                        T
                    </v-btn>
                    <v-btn fab dark small color="indigo" @click="appendLetter('U')">
                        U
                    </v-btn>
                    <v-btn fab dark small color="indigo" @click="appendLetter('V')">
                        V
                    </v-btn>
                    <v-btn fab dark small color="indigo" @click="appendLetter('W')">
                        W
                    </v-btn>
                    <v-btn fab dark small color="indigo" @click="appendLetter('X')">
                        X
                    </v-btn>
                    <v-btn fab dark small color="indigo" @click="appendLetter('Y')">
                        Y
                    </v-btn>
                    <v-btn fab dark small color="indigo" @click="appendLetter('Z')">
                        Z
                    </v-btn>
                </div>
            </v-form>


        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: 'RukoGarantD12',
        data() {
            return {
                string: '',
                snackbar: false,
                positionMatrix: {
                    1: {
                        Q: 'A',
                        F: 'b',
                        R: 'D',
                        U: 'E',
                        L: 'h',
                        E: 'j',
                        T: 'F',
                        W: 'J',
                        S: 'L',
                        B: 'N',
                        K: 'R',
                        D: 'T',
                        Y: 'r',
                        M: 'u',
                        A: 'w'
                    },
                    2: {
                        K: 'A',
                        J: 'b',
                        R: 'D',
                        T: 'E',
                        M: 'h',
                        N: 'j',
                        A: 'F',
                        B: 'J',
                        C: 'L',
                        W: 'N',
                        P: 'R',
                        U: 'T',
                        H: 'r',
                        E: 'u',
                        S: 'w'
                    },
                    3: {
                        W: 'A',
                        E: 'b',
                        Y: 'D',
                        I: 'E',
                        N: 'h',
                        A: 'j',
                        V: 'F',
                        S: 'J',
                        D: 'L',
                        F: 'N',
                        J: 'R',
                        Q: 'T',
                        U: 'r',
                        G: 'u',
                        R: 'w'
                    },
                    4: {
                        H: 'A',
                        F: 'b',
                        A: 'D',
                        Z: 'E',
                        M: 'h',
                        R: 'j',
                        N: 'F',
                        P: 'J',
                        Y: 'L',
                        K: 'N',
                        Q: 'R',
                        T: 'T',
                        J: 'r',
                        E: 'u',
                        B: 'w'
                    },
                    5: {
                        W: 'A',
                        R: 'b',
                        K: 'D',
                        U: 'E',
                        C: 'h',
                        T: 'j',
                        V: 'F',
                        S: 'J',
                        J: 'L',
                        Q: 'N',
                        A: 'R',
                        H: 'T',
                        D: 'r',
                        G: 'u',
                        F: 'w'
                    },
                    6: {
                        R: 'A',
                        W: 'b',
                        D: 'D',
                        U: 'E',
                        E: 'h',
                        B: 'j',
                        Z: 'F',
                        N: 'J',
                        X: 'L',
                        A: 'N',
                        F: 'R',
                        K: 'T',
                        T: 'r',
                        G: 'u',
                        S: 'w'
                    },

                }
            }
        },
        methods: {
            resetString() {
                this.string = '';
            },
            appendLetter(letter) {
                if (this.string.length < 6) {
                    this.string = this.string + letter;
                } else {
                    this.snackbar = true;
                }
            }
        },
        computed: {
            result() {

                let result = '';
                let value = this.string;
                for (let i = 0; i < value.length; i++) {

                    let letter = value.charAt(i);

                    if(typeof this.positionMatrix[i + 1][letter] !== "undefined"){
                        result = result + this.positionMatrix[i + 1][letter];
                    }else{
                        result = result + ' ';
                    }

                }
                return result;
            }
        }
    }
</script>